const useStyle = () => {
    const getCSSValue = (cssVariableName: string): string => {
        const value = getComputedStyle(document.documentElement)
            .getPropertyValue(cssVariableName)
            .trim();

        if (value === '') {
            console.debug(`CSS variable ${cssVariableName} is not yet resolved`);
        }

        return value;
    };

    return {
        getCSSValue
    };
};

export default useStyle;
